"use strict";
var callBound = require("call-bound");
var hasToStringTag = require("has-tostringtag/shams")();
var hasOwn = require("hasown");
var gOPD = require("gopd");
var fn;
if (hasToStringTag) {
  var $exec = callBound("RegExp.prototype.exec");
  var isRegexMarker = {};
  var throwRegexMarker = function() {
    throw isRegexMarker;
  };
  var badStringifier = {
    toString: throwRegexMarker,
    valueOf: throwRegexMarker
  };
  if (typeof Symbol.toPrimitive === "symbol") {
    badStringifier[Symbol.toPrimitive] = throwRegexMarker;
  }
  fn = function isRegex(value) {
    if (!value || typeof value !== "object") {
      return false;
    }
    var descriptor = (
      /** @type {NonNullable<typeof gOPD>} */
      gOPD(
        /** @type {{ lastIndex?: unknown }} */
        value,
        "lastIndex"
      )
    );
    var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, "value");
    if (!hasLastIndexDataProperty) {
      return false;
    }
    try {
      $exec(
        value,
        /** @type {string} */
        /** @type {unknown} */
        badStringifier
      );
    } catch (e) {
      return e === isRegexMarker;
    }
  };
} else {
  var $toString = callBound("Object.prototype.toString");
  var regexClass = "[object RegExp]";
  fn = function isRegex(value) {
    if (!value || typeof value !== "object" && typeof value !== "function") {
      return false;
    }
    return $toString(value) === regexClass;
  };
}
module.exports = fn;
